/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboStructsDefendifySettingRequest } from './JumboStructsDefendifySettingRequest';
import {
    JumboStructsDefendifySettingRequestFromJSON,
    JumboStructsDefendifySettingRequestFromJSONTyped,
    JumboStructsDefendifySettingRequestToJSON,
} from './JumboStructsDefendifySettingRequest';

/**
 * 
 * @export
 * @interface JumboPostdefendifysettingsPostDefendifySettingsRequestBody
 */
export interface JumboPostdefendifysettingsPostDefendifySettingsRequestBody {
    /**
     * 
     * @type {Array<JumboStructsDefendifySettingRequest>}
     * @memberof JumboPostdefendifysettingsPostDefendifySettingsRequestBody
     */
    settings: Array<JumboStructsDefendifySettingRequest>;
}

/**
 * Check if a given object implements the JumboPostdefendifysettingsPostDefendifySettingsRequestBody interface.
 */
export function instanceOfJumboPostdefendifysettingsPostDefendifySettingsRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "settings" in value;

    return isInstance;
}

export function JumboPostdefendifysettingsPostDefendifySettingsRequestBodyFromJSON(json: any): JumboPostdefendifysettingsPostDefendifySettingsRequestBody {
    return JumboPostdefendifysettingsPostDefendifySettingsRequestBodyFromJSONTyped(json, false);
}

export function JumboPostdefendifysettingsPostDefendifySettingsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostdefendifysettingsPostDefendifySettingsRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'settings': ((json['settings'] as Array<any>).map(JumboStructsDefendifySettingRequestFromJSON)),
    };
}

export function JumboPostdefendifysettingsPostDefendifySettingsRequestBodyToJSON(value?: JumboPostdefendifysettingsPostDefendifySettingsRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'settings': ((value.settings as Array<any>).map(JumboStructsDefendifySettingRequestToJSON)),
    };
}

